import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '@shared/api/client';
import { CREDENTIALS, BITRIX_STORE } from '@shared/api/endpoints';
import type {
  SavedCredential,
  BitrixCredentials,
  CredentialSaveResponse,
} from '@tailorcast/shared-types';

export function useCredentials() {
  return useQuery({
    queryKey: ['credentials'],
    queryFn: () => api.get<{ credentials: SavedCredential[] }>(CREDENTIALS.LIST),
  });
}

export function useSaveCredentials() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (credentials: BitrixCredentials) =>
      api.post<CredentialSaveResponse>(CREDENTIALS.SAVE, credentials),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['credentials'] });
    },
  });
}

export function useSaveBitrixStoreSetup() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (body: { catalogIblockId: string; catalogGroupId: string }) =>
      api.post<CredentialSaveResponse>(BITRIX_STORE.SETUP, body),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['credentials'] });
    },
  });
}

export function useDeleteCredentials() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => api.delete<{ deleted: boolean }>(CREDENTIALS.DELETE('bitrix')),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['credentials'] });
    },
  });
}
